import React, { createContext, useContext, useState, useEffect } from 'react';

export const WORKER_URL = 'https://integra-mkt-api.bot-mercadoflow.workers.dev';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('saas_token');
    if (!token) { setLoading(false); return; }

    fetch(`${WORKER_URL}/api/auth/me`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        if (data?.user) setUser(data.user);
        else localStorage.removeItem('saas_token');
      })
      .catch(() => localStorage.removeItem('saas_token'))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const res = await fetch(`${WORKER_URL}/api/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Erro ao entrar');
    localStorage.setItem('saas_token', data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (email, password, name, emailCode, phone, smsCode, referralCode) => {
    const res = await fetch(`${WORKER_URL}/api/auth/register`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password, name, emailCode, phone, smsCode, ...(referralCode ? { referralCode } : {}) })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Erro ao cadastrar');
    localStorage.setItem('saas_token', data.token);
    if (referralCode) localStorage.removeItem('referral_code');
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    const token = localStorage.getItem('saas_token');
    if (token) {
      fetch(`${WORKER_URL}/api/auth/logout`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` }
      }).catch(() => {});
    }
    localStorage.removeItem('saas_token');
    setUser(null);
    window.location.href = '/';
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
